module.exports = __webpack_public_path__ + "img/speelWolk.84ec376d.svg";